import Navbar from './components/Navbar';
import Hero from './components/Hero';
import HomepageTeaser from './components/HomepageTeaser';
import Footer from './components/Footer';
import useSEO from '@/hooks/useSEO';
import SchemaOrg from '@/components/feature/SchemaOrg';

const siteUrl = import.meta.env.VITE_SITE_URL ?? 'https://example.com';

const homeSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'RealEstateAgent',
    name: 'Higher Standard Global',
    url: siteUrl,
    logo: `${siteUrl}/favicon.svg`,
    description:
      'Higher Standard Global offers premium rental management for long-term, short-term, and vacation properties. Expert tenant screening, lease management, and maintenance coordination for select clientele by referral only.',
    telephone: '+1-307-218-3610',
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'US',
    },
    sameAs: [],
    areaServed: 'Worldwide',
    priceRange: '$$$',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Higher Standard Global',
    url: siteUrl,
    description:
      'Premium rental property management for discerning owners. By reference only.',
  },
];

export default function HomePage() {
  useSEO({
    title: 'Higher Standard Global | Premium Rental Property Management',
    description:
      'Higher Standard Global offers premium rental management for long-term, short-term, and vacation properties. Expert tenant screening, lease management, and maintenance coordination for select clientele by referral only.',
    keywords: 'rental management, property management, tenant screening, lease management, vacation property management',
    canonical: '/',
    ogTitle: 'Higher Standard Global | Premium Rental Property Management',
    ogDescription: 'Curated property management for discerning owners. By reference only.',
  });

  return (
    <main className="w-full min-h-screen">
      <SchemaOrg schema={homeSchema} id="schema-home" />
      <Navbar />
      <Hero />
      <HomepageTeaser />
      <Footer />
    </main>
  );
}
